import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21.957 7.963V1.999c0-.586-.4-.977-1-.977s-1 .39-1 .977v3.617l-2.9-2.736c-1-.977-2.3-1.857-3.7-2.346-5.3-1.76-11 .978-12.8 6.06-1.8 5.085.9 10.657 6.1 12.514 1.1.293 2.2.489 3.3.489 4.1 0 8-2.542 9.4-6.55.2-.49-.1-1.075-.6-1.27s-1.1.097-1.3.586c-1.5 4.106-6 6.159-10.2 4.79-4.2-1.467-6.3-5.867-4.9-9.973 1.5-4.008 6.1-6.16 10.3-4.693 1.1.39 2.2.978 3 1.858l2.8 2.54h-3.5c-.6 0-1 .392-1 .979 0 .586.4.977 1 .977h6c.1 0 .2 0 .2-.097h.1l.1-.098c.1 0 .2-.098.2-.196 0-.097 0-.097.1-.097 0-.098.1-.098.1-.196.2 0 .2-.097.2-.194"
    }, null, -1)
  ]))]))
}
export default { render: render }